export default __webpack_public_path__ + "static/media/user_edit_icon.13a70dd0.svg";